module.exports = __webpack_public_path__ + "static/Tony_Vien-Resume-48c7baf76695ae6c34b03e190e7608e3.pdf";